
export interface DepartmentJSON {
  id: string
  faculty_id: string
  name: string
  description?: string | null
  is_active?: boolean | null
  created_at?: string | null
  updated_at?: string | null
}

export class Department {
  readonly id: string
  readonly facultyId: string
  readonly name: string
  readonly description?: string
  readonly isActive: boolean
  readonly createdAt?: string
  readonly updatedAt?: string

  constructor(options: {
    id: string
    facultyId: string
    name: string
    description?: string
    isActive?: boolean
    createdAt?: string
    updatedAt?: string
  }) {
    this.id = options.id
    this.facultyId = options.facultyId
    this.name = options.name
    this.description = options.description
    this.isActive = options.isActive ?? true
    this.createdAt = options.createdAt ?? undefined
    this.updatedAt = options.updatedAt ?? undefined
  }

  static fromJSON(json: DepartmentJSON): Department {
    return new Department({
      id: json.id,
      facultyId: json.faculty_id,
      name: json.name,
      description: json.description ?? undefined,
      isActive: json.is_active ?? true,
      createdAt: json.created_at ?? undefined,
      updatedAt: json.updated_at ?? undefined,
    })
  }
}
